// extracted by mini-css-extract-plugin
export default {"container":"rWXue_","left":"rIhyE1","right":"reqvJS"};